<template>
  <fragment>
    <span v-if="isTitleVisible" class="font_Montserrat font_size_1000rem v3_color_black_knight1">
      {{ title }}
    </span>
    <div class="survey-results-chart-pie" :class="{'border_1 border_grey' : isBorderVisible}">
      <highcharts :options="chartOptions" />
    </div>
    <template v-if="isStatsVisible">
      <div
        v-if="responsesCount"
        class="text-right survey-results__responses-count mt-1"
      >
        <span>N = {{ responsesCount | formatNumber }}</span>
      </div>
    </template>
  </fragment>
</template>

<script>
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import FormatNumberFilterMixin from '@/mixins/FormatNumberFilterMixin';
import treemap from 'highcharts/modules/treemap';
import heatmap from 'highcharts/modules/heatmap';
import { getCharHeightForChartTypeAndWidth } from '@/helpers/chartsHelper';
import { QUESTION_TYPES } from '@/store';
treemap(Highcharts);
heatmap(Highcharts);

export default {
  name: 'SurveyResultsChartTreemap',
  mixins: [FormatNumberFilterMixin],
  components: {
    highcharts: Chart,
  },
  props: {
    title: String,
    questionType: String,
    results: Array,
    format: String, // 'dashboard' / 'results' / 'filters'
    responsesCount: [Number, String],
    layout: {
      type: String,
      default: 'sliceAndDice', // 'stripes', 'squarified', 'strip'
    },
    isStatsVisible: {
      type: Boolean,
      default: true,
    },
    isTitleVisible: {
      type: Boolean,
      default: true
    },
    isBorderVisible: {
      type: Boolean,
      default: true
    },
  },
  watch: {
    windowWidth: function () {
      this.updateChartHeight();
    },
    results: function () {
      // refresh data series
      this.chartOptions.series[0].data = this.getSeriesData();
      this.chartOptions.colorAxis.max = Math.max(
        ...this.results.map((r) => +r.value_count)
      );
    },
  },
  data: function () {
    return {
      chartOptions: {
        chart: {
          backgroundColor: 'transparent',
          events: {
            render: () => this.$emit('chart-rendered'),
          },
          type: 'treemap',
          height: getCharHeightForChartTypeAndWidth(
            this.type,
            this.windowWidth
          ),
          // width: 700
        },
        title: undefined,
        legend: { enabled: false },
        credits: { enabled: false },
        // colors: colors,
        plotOptions: {
          treemap: {
            allowPointSelect: true,
            cursor: 'pointer',
            layoutAlgorithm: this.layout,
            dataLabels: {
              enabled: true,
              formatter: this.getDataLabelsFormatter(),
            },
          },
          series: {
            color: '#5AC3D8',
          },
        },
        colorAxis: {
          min: 0,
          max: Math.max(...this.results.map((r) => +r.value_count)),
        },
        series: [
          {
            data: this.results.map((r) => {
              return {
                name: this.getDataPointName(r),
                value: +r.value_count,
                colorValue: +r.value_count,
              };
            }),
          },
        ],
      },
    };
  },
  methods: {
    getDataPointName(result) {
      if (this.questionType === QUESTION_TYPES.YES_NO) {
        if (result.value === 1) {
          return 'Yes';
        } else {
          return 'No';
        }
      } else if (
        this.questionType === QUESTION_TYPES.MULTI_VARIABLE_SELECT_ONE
      ) {
        return result.value;
      } else {
        return result.label;
      }
    },
    getDataLabelsFormatter() {
      return function () {
        return `<b>${this.point.name}</b>: ${this.point.value}`;
      };
    },
    getSeriesData: function () {
      return this.results.map((r) => {
        return {
          name: this.getDataPointName(r),
          y: +r.value_count,
        };
      });
    },
    updateChartHeight: function () {
      this.chartOptions.chart.height = getCharHeightForChartTypeAndWidth(
        this.format,
        this.windowWidth
      );
    },
  },
  created: function () {
    this.updateChartHeight();
  },
};
</script>

<style lang="scss"></style>
